import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {TenantApartment} from "../../_models/tenant-apartments.model";

export const loadTenantInfo = createAction(
    '[Tenant Apartments] Load Tenant Info',
    props<{ apartmentId: string }>()
);

export const loadTenantInfoSuccess = createAction(
    '[Tenant Apartments] Load Tenant Info Success',
    props<{ tenantInfo: TenantApartment }>()
);

export const loadTenantInfoFailure = createAction(
    '[Tenant Apartments] Load Tenant Info Failure',
    props<{ error: HttpErrorResponse }>()
);
